










































import { Component, Vue, Prop, Watch } from "@/shared/vuepack";
import * as SharedRoutes from "@/shared/route-names";
import { AuthType, LoginMethod } from "@/shared/types";
import { useMfaStore } from "@/shared/store/mfa";
import { useCustodianSettingsStore } from "@/shared/store/custodianSettings";
import { useFeatureFlagStore } from "@/shared/store/featureFlag";
import { useUserStore } from "@/shared/store/user";
import { useThemeStore } from "@/shared/store/theme";

@Component({
  components: {
  }
})
export default class AddMfa extends Vue {

  mfaStore = useMfaStore();
  custodianSettingsStore = useCustodianSettingsStore();
  featureFlagStore = useFeatureFlagStore();
  userStore = useUserStore();
  themeStore = useThemeStore();
  loginMethodType = LoginMethod;

  show = false;

  @Prop()
  settingsOverride: () => string;

  created () {
    this.initialize();
  }

  @Watch("mfaStore.showMfaModal")
  initialize () {
    this.show = this.custodianSettingsStore.allowMfa
        && this.mfaStore.showMfaModal
        && this.userStore.loginMethod !== this.loginMethodType.Sso;
  }

  get linkRoute () {
    if (!this.settingsOverride) {
      return { name: SharedRoutes.Security };
    }

    const s = this.settingsOverride();
    return {
      name: s ? s : SharedRoutes.Security
    };
  }

  get isOkta () {
    return this.userStore.authType === AuthType.Okta;
  }

  skip () {
    this.mfaStore.setShowMfa(false);
  }

  stop () {
    this.mfaStore.setMfaPreference(false);
  }

  onHidden (e) {
    this.skip();
  }
}
